import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { FC } from 'react';
import { DiscountWrapper, OrderAmountTitle, OrderAmountValue, OrderAmountWrapper } from './OrderAmount.styles';

// This is to render the subtotal, tax, shipping fee, and total lines
// Total line is bold
interface AmountRowProps {
  title: string;
  value?: string;
  isBoldText?: boolean;
}

const AmountRow = ({ title, value, isBoldText }: AmountRowProps) => {
  if (!value) return null;
  return (
    <>
      <OrderAmountTitle isBoldText={isBoldText}>{title}</OrderAmountTitle>
      <OrderAmountValue isBoldText={isBoldText}>{value}</OrderAmountValue>
    </>
  );
};

// This is to render the discount lines
// Discount lines are not bold and render multiple lines
interface DiscountRowProps {
  title: string;
  value?: string[];
}

const DiscountRow = ({ title, value }: DiscountRowProps) => {
  if (!value) return null;
  return (
    <>
      <OrderAmountTitle>{title}</OrderAmountTitle>
      <DiscountWrapper>
        {value.map((discount: string, index: number) => (
          <OrderAmountValue key={`${index}-${discount}`}>{`-${discount}`}</OrderAmountValue>
        ))}
      </DiscountWrapper>
    </>
  );
};

interface OrderAmountProps {
  tax?: string;
  total?: string;
  subtotal?: string;
  discounts?: string[];
  shippingFee?: string;
}

export const OrderAmount: FC<OrderAmountProps> = ({ tax, total, subtotal, discounts, shippingFee }) => {
  const { t } = useGlobalState();
  return (
    <OrderAmountWrapper>
      {/* Subtotal */}
      <AmountRow title={t(MasterTranslation.Subtotal)} value={subtotal} />

      {/* Tax */}
      <AmountRow title={t(MasterTranslation.Tax)} value={tax} />

      {/* Shipping Fee */}
      <AmountRow title={t(MasterTranslation.ShippingFee)} value={shippingFee} />

      {/* Discount */}
      <DiscountRow title={t(MasterTranslation.Discount)} value={discounts} />

      {/* Total */}
      <AmountRow isBoldText title={t(MasterTranslation.Total)} value={total} />
    </OrderAmountWrapper>
  );
};
